var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto",
        "objc_class_prefix": "DynamicType"
    },
    "messages": [
        {
            "name": "DynamicUserInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "userName",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "avatar",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "gender",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "officialAuth",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "officialAuthContent",
                    "id": 7
                }
            ]
        },
        {
            "name": "DynamicContent",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "coverUrl",
                    "id": 1
                },
                {
                    "rule": "repeated",
                    "type": "string",
                    "name": "resourceUrls",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "text",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "DynamicUserInfo",
                    "name": "videoSourceUserInfo",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "resourceDesp",
                    "id": 6
                }
            ]
        },
        {
            "name": "DynamicShareInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "shareUrl",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "facebookShareUrl",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "title",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "desc",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "platformUrl",
                    "id": 5
                }
            ]
        },
        {
            "name": "DynamicAnchorLiveInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "roomId",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "liveType",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "enterNeedDiamond",
                    "id": 3
                }
            ]
        },
        {
            "name": "DynamicInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "rid",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "dynamicId",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "dynamicType",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "status",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "DynamicUserInfo",
                    "name": "userInfo",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "DynamicContent",
                    "name": "content",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "bool",
                    "name": "liked",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "commentNum",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "likeNum",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "shareNum",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "createTime",
                    "id": 11
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "updateTime",
                    "id": 12
                },
                {
                    "rule": "optional",
                    "type": "DynamicShareInfo",
                    "name": "dynamicShareInfo",
                    "id": 13
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "official",
                    "id": 14
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "playNum",
                    "id": 15
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "followStatus",
                    "id": 16
                },
                {
                    "rule": "optional",
                    "type": "DynamicAnchorLiveInfo",
                    "name": "liveInfo",
                    "id": 17
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "topicId",
                    "id": 18
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "topicName",
                    "id": 19
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "musicId",
                    "id": 20
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "musicName",
                    "id": 21
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "musicUrl",
                    "id": 22
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "example",
                    "id": 23
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "isNews",
                    "id": 24
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "ab",
                    "id": 25
                }
            ]
        },
        {
            "name": "DynamicTopic",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "regionCode",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "topicId",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "topicName",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "coverUrl",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "summary",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "recommendLocation",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "newLocation",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "showLocation",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "isHot",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "status",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "allVideoNum",
                    "id": 11
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "partakeNum",
                    "id": 12
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "onLookNum",
                    "id": 13
                },
                {
                    "rule": "repeated",
                    "type": "DynamicInfo",
                    "name": "dnamicInfos",
                    "id": 14
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "newUrl",
                    "id": 15
                }
            ]
        },
        {
            "name": "Dynamic",
            "fields": [],
            "messages": [
                {
                    "name": "TopicHots",
                    "fields": [],
                    "options": {
                        "objc_class_prefix": "DynamicTopicHots",
                        "java_package": "com.asiainno.uplive.proto"
                    },
                    "messages": [
                        {
                            "name": "Request",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int64",
                                    "name": "topicId",
                                    "id": 1
                                }
                            ]
                        },
                        {
                            "name": "Response",
                            "fields": [
                                {
                                    "rule": "repeated",
                                    "type": "DynamicInfo",
                                    "name": "hotDynamicList",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "DynamicTopic",
                                    "name": "topicInfo",
                                    "id": 2
                                },
                                {
                                    "rule": "repeated",
                                    "type": "DynamicTopic",
                                    "name": "recommendTopicInfos",
                                    "id": 3
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "enums": [
        {
            "name": "DynamicType",
            "values": [
                {
                    "name": "TYPE_DEFAULT",
                    "id": 0
                },
                {
                    "name": "IMAGE_TEXT",
                    "id": 1
                },
                {
                    "name": "VIDEO_TEXT",
                    "id": 2
                },
                {
                    "name": "COMMENT",
                    "id": 3
                },
                {
                    "name": "LIKE",
                    "id": 4
                },
                {
                    "name": "SCREEN_VIDEO",
                    "id": 5
                },
                {
                    "name": "SHARE",
                    "id": 6
                },
                {
                    "name": "VIDEO_CAPTURE",
                    "id": 7
                },
                {
                    "name": "VIDEO_PLAY",
                    "id": 8
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/component/topic/detail.pb.js